import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useShippingsStore } from "../../store/shippings.store";

export const useShipping = () => {
  const setShipping = useShippingsStore((state) => state.setShipping);

  return useMutation(PartnerApi.shipping, {
    onSuccess: (data) => {
      setShipping(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};

export const useShippingGlsPackingList = () => {
  const setGlsPackagesList = useShippingsStore((state) => state.setGlsPackagesList);

  return useMutation(PartnerApi.glsPackagesList, {
    onSuccess: (data) => {
      setGlsPackagesList(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
